module.exports = __webpack_public_path__ + "static/media/5ed7398d31d6be3b4dcffa3c.20a2bcb0.png";